import {
    AccordionDetails as MUIAccordionDetails,
    AccordionDetailsProps as MUIAccordionDetailsProps,
  } from "@mui/material";
  import * as React from "react";
  
  type AccordionDetailsProps = MUIAccordionDetailsProps & {};
  const AccordionDetails = (props: AccordionDetailsProps) => {
    return <MUIAccordionDetails {...props}>{props.children}</MUIAccordionDetails>;
  };
  
  export default AccordionDetails;
  